import { ScheduleDetailsData } from './schedule-details-data';

export interface ScheduleDetailsDetails {
  type: ScheduleDetailsType;
  data: ScheduleDetailsData;
}

export enum ScheduleDetailsType {
  lecture,
  exam,
}
